/**
 * CalendlySettings — placeholder while Calendly integration is finalized.
 */

import { Calendar, Clock } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function CalendlySettings() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-primary" />
          <CardTitle>Calendly Integration</CardTitle>
        </div>
        <CardDescription>
          When a prospect is ready to book a meeting, we'll automatically send your Calendly link.
        </CardDescription>
      </CardHeader>

      <CardContent>
        <div className="flex flex-col items-center gap-3 py-8 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
            <Clock className="h-6 w-6 text-muted-foreground" />
          </div>
          <h3 className="text-sm font-semibold">Coming Soon</h3>
          <p className="max-w-sm text-sm text-muted-foreground">
            Calendly integration is being finalized. You'll be able to connect your booking
            link here so prospects can schedule meetings automatically.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
